import { render, staticRenderFns } from "./DirectPlacementList.vue?vue&type=template&id=2c3bb012"
import script from "./DirectPlacementList.vue?vue&type=script&lang=js"
export * from "./DirectPlacementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports